export type UnlockModalVariant = 'reading' | 'grammar' | 'default'

export const UNLOCK_MODAL_KEYS: Record<
  UnlockModalVariant,
  { titleId: string; descId: string; unlockBtnId: string; cancelBtnId: string }
> = {
  reading: {
    titleId: 'unlockThatLessonReading',
    descId: 'unlockThatLessonDescReading',
    unlockBtnId: 'unlockThatLessonReadingUnlock',
    cancelBtnId: 'unlockThatLessonReadingCancel',
  },
  grammar: {
    titleId: 'unlockThatLessonGrammar',
    descId: 'unlockThatLessonDescGrammar',
    unlockBtnId: 'unlockThatLessonGrammarUnlock',
    cancelBtnId: 'unlockThatLessonGrammarCancel',
  },
  default: {
    titleId: 'unlockThatLesson?',
    descId: 'unlockThatLessonDesc',
    unlockBtnId: 'unlock',
    cancelBtnId: 'cancel',
  },
}

export function getUnlockModalVariant(
  modalType: 'lesson' | 'topic',
  lessonType?: string,
): UnlockModalVariant {
  if (modalType !== 'lesson') return 'default'
  const type = lessonType?.toLowerCase()
  if (type === 'reading') return 'reading'
  if (type === 'grammar1' || type === 'grammar2') return 'grammar'
  return 'default'
}

export function getUnlockModalMessageIds(
  modalType: 'lesson' | 'topic',
  lessonType?: string,
) {
  const variant = getUnlockModalVariant(modalType, lessonType)
  if (variant === 'default' && modalType === 'topic') {
    return {
      titleId: 'unlockThatTopic?',
      descId: 'unlockThatTopicDesc',
      unlockBtnId: 'unlock',
      cancelBtnId: 'cancel',
    }
  }
  return UNLOCK_MODAL_KEYS[variant]
}
